import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { LookupService } from 'src/app/services/lookup-data.service';
import { AttorneyProfileService } from 'src/app/services/attorney-profile.service';
import { Observable, forkJoin, combineLatest } from 'rxjs';
import * as errorUtils from "src/app/modules/utility/global-utils";
import * as fromTask from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { USER_PERMISSIONS } from 'src/app/data/constants/permissions';
import { SubTaskDetails } from "src/app/data/models/subTaskDetails.model";
import * as Task from 'src/app/modules/superTask/task-state/actions/task.actions';
import { take, takeUntil } from 'rxjs/operators';
import { SubTask, SuperTask } from 'app-models';

@Component({
  selector: 'app-rfe-task',
  templateUrl: './rfe-task.component.html',
  styleUrls: ['./rfe-task.component.scss']
})
export class RfeTaskComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;
  rfeTaskForm: FormGroup
  serviceCenters: any[] = [];
  reviewUsersList: any[] = [];
  attorneys: any[] = [];
  attorneyUsers: any[] = [];
  users: any[] = [];
  selectedSignatory: any;
  selectedDesignation: any;
  selectedPreparer: any;
  selectedPetetionPreprarer: any;
  stepsData: TaskStep[];
  taskId;
  taskType = 'RFE';
  taskTypeDetails = null;
  petitionId;
  userName;
  noticeNumber;
  isOutsideImagility: boolean = true;
  oldServiceCenterName: string;
  oldAttorneyCompanyName: string;
  oldPreparerAttorneyName: string;
  subTaskOverView: SubTask;
  superTaskDetails: SuperTask;
  employeeDetails: any;
  isAttorneySelect: boolean;
  userType: string;
  primaryCompanyId: number;
  rfeSubTaskDetails: SubTaskDetails;



  constructor(private fb: FormBuilder,
    private lookupService: LookupService,
    private petitionerService: PetitionerService,
    private activatedRoute: ActivatedRoute, private store: Store<fromTask.State>,
    private attorneyProfileService: AttorneyProfileService) {
    this.rfeTaskForm = this.fb.group({
      authorizedSignatoryId: ['', Validators.required],
      processingType: ['', Validators.required],
      serviceCenterId: ['', Validators.required],
      attorneyId: [''],
      immSpecialistId: [null, Validators.required],
      preparerAttorneyId: [0],
      immigrantTypeCode: [''],
      isAttorneySame: [0],
      isCaseTransferred: [0],
      selectedDesignation: [''],
    })


  }

  ngOnInit(): void {
    //adding sub form controls to the parent form
    if (this.rfeTaskForm) {
      for (const [key, value] of Object.entries(this.rfeTaskForm.controls)) {
        this.parentFormGroup?.addControl(key, value);
      }

    }

    this.userType = sessionStorage.getItem('userTypeRole');
    this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));

    combineLatest([
      this.store.select(fromTask.getSuperTask),
      this.store.select(fromTask.getRFESubTask),
      this.store.select(fromTask.getRFESubTaskDetails)

    ]).subscribe(([superTask, rfeSubTask, rfeSubTaskDetails]) => {
      if (superTask) {
        this.subTaskOverView = rfeSubTask;
        this.store.dispatch(new Task.SetActiveSubTaskIndex(this.subTaskOverView.id));
        this.superTaskDetails = superTask;
        this.taskId = this.subTaskOverView.id;
        this.rfeSubTaskDetails = rfeSubTaskDetails;
        // console.log("$$$$ SubTaskOverView",this.subTaskOverView,this.superTaskDetails,"rfeTabIndex",this.rfeSubTaskDetails);
        if (rfeSubTaskDetails) {
          this.getTaskDetails();
        }
      }
    });

    combineLatest([
      this.lookupService.getReviewersUser(this.parentFormGroup.get('companyId').value, USER_PERMISSIONS.PETITION_REVIEWER),
      this.lookupService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId')),
      this.lookupService.getUsersOfCompany(this.parentFormGroup.get('companyId').value)
    ])
      .pipe(take(1))
      .subscribe(data => {
        this.reviewUsersList = data[0];
        this.attorneys = data[1];
        this.users = data[2];
        console.log('data1 >>>>', data);
        const assignedSignotory = this.reviewUsersList.find((ru)=> ru.id === this.parentFormGroup.value.authorizedSignatoryId);
        if(assignedSignotory){
          this.rfeTaskForm.patchValue({
            authorizedSignatoryId: assignedSignotory.id
          });
          this.userSelected();
        }
      });


    // console.log("SubtaskId",this.subTaskId)


    if (this.userType === 'Attorney') {
      this.attorneyProfileService.getEmployeeDetails(this.primaryCompanyId, parseInt(sessionStorage.getItem('employeeId'))).subscribe(data => {
        this.employeeDetails = data;
        console.log('data2 >>>>', data);
        sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
        if (!this.taskId) {
          this.rfeTaskForm.patchValue({
            attorneyId: data['companyId'],
            preparerAttorneyId: data['id']
          })

        }


      });
      this.isAttorneySelect = false;

    }
    else {
      this.isAttorneySelect = true;
    }
    //disabling the form controls beneficiary
    if (this.userType === 'Beneficiary') {
      for (const [key, value] of Object.entries(this.rfeTaskForm.controls)) {
        this.rfeTaskForm.controls[key].disable();
      }
    } else {
      for (const [key, value] of Object.entries(this.rfeTaskForm.controls)) {
        this.rfeTaskForm.controls[key].enable();
        if (this.taskId) {
          // this.rfeTaskForm.get('attorneyId').disable();
          this.rfeTaskForm.controls['attorneyId'].disable();
          this.rfeTaskForm.controls['preparerAttorneyId'].disable();
        }
      }
    }


  }

  getTaskDetails() {

    const response = this.rfeSubTaskDetails;

    //console.log("get response",response);
    if (response) {
      this.taskId = response['id'];
      this.petitionId = response['petitionId'];
      sessionStorage.setItem('petitionId', this.petitionId);
      this.noticeNumber = response['noticeNumber'];
      this.stepsData = response['taskStepDetails'];
      this.taskTypeDetails = response['taskTypeDetails'];
      this.userName = `${response['beneficiaryDetails'].firstName} ${response['beneficiaryDetails'].lastName}`;
      this.isOutsideImagility = response['isOutsideImagility'] ? true : false;
      this.oldServiceCenterName = response['oldServiceCenterDetails'] && response['oldServiceCenterDetails']['serviceCenterName'] ? response['oldServiceCenterDetails']['serviceCenterName'] : '';
      this.oldPreparerAttorneyName = response['oldPreparerAttorneyName'] ? response['oldPreparerAttorneyName'] : '';
      this.oldAttorneyCompanyName = response['oldAttorneyCompanyName'] ? response['oldAttorneyCompanyName'] : '';
      let attorneyId = response.attorneyId ? response.attorneyId : (this.userType === 'Attorney' && !this.taskId) ? sessionStorage.getItem('companyId') : response.attorneyId;
      //let attorneyId =
      let attorneyUsers = this.lookupService.getUsersOfCompany(attorneyId);
      let users = this.lookupService.getUsersOfCompany(response.companyId);
      let reviewers = this.lookupService.getReviewersUser(response.companyId, USER_PERMISSIONS.PETITION_REVIEWER);
      let attorneyCompany = this.taskId ? this.lookupService.getActiveAttorneyCompanyList(response.companyId) : this.lookupService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId'));
      let serviceCenters = this.lookupService.getServiceCenters((response.processingType == 'regular') ? 'false' : 'true', response['taskTypeDetails']['visaType'], response['taskTypeDetails']['petitionType']);
      //  let companyListAssociatedWithAttorney = this.attorneyService.getClientsList(this.primaryCompanyId, reqJson)
      forkJoin([attorneyUsers, users, reviewers, attorneyCompany, serviceCenters]).subscribe(results => {
        console.log('reviewUsersList', results);

        if (results) {
          //console.log("$$$$ Array Results",results);
          this.reviewUsersList = results[2] as any;
          this.attorneys = results[3] as any;
          this.attorneyUsers = results[0] as any;
          this.serviceCenters = results[4] as any;
          this.users = results[1] as any;
          this.rfeTaskForm.patchValue({
            authorizedSignatoryId: response['signatoryId'],
            processingType: response['processingType'],
            serviceCenterId: response['serviceCenterId'],
            attorneyId: response['attorneyId'],
            immSpecialistId: response['immSpecialistId'],
            preparerAttorneyId: response['preparerAttorneyId'],
            immigrantTypeCode: response['immigrantTypeCode'],
            isAttorneySame: response['isAttorneySame'],
            isCaseTransferred: response['isCaseTransferred'] ? true : false,
            selectedDesignation: response['signatoryDetails']['designation']
          });
          this.selectedSignatory = response['signatoryDetails'];
          //userSelected
          this.userPreparerSelected();
          this.onPetitionerPreparerSelected();
          //this.selectedPreparer = response[]

          // console.log("After patch form value",this.rfeTaskForm)

        }
      });



    }





    // });

  }

  onChangeProcessingType() {
    this.serviceCenters = [];
    this.getServiceCenter();
  }

  getServiceCenter() {
    this.rfeTaskForm.patchValue({
      serviceCenterId: ''
    });

    this.rfeTaskForm.get('serviceCenterId').reset();
    let processingType = this.rfeTaskForm.get('processingType').value;
    let visaType = this.taskId ? this.superTaskDetails.visaType.code : this.parentFormGroup.get('visaType').value;
    let petitionType = this.taskId ? this.superTaskDetails.petitionType.code : this.parentFormGroup.get('petitionType').value;
    this.lookupService.getServiceCenters((processingType == 'regular') ? 'false' : 'true', visaType, petitionType).subscribe((data: Array<any>) => {
      this.serviceCenters = data;
    });
  }

  userSelected() {
    let id = this.rfeTaskForm.get('authorizedSignatoryId').value;
    this.selectedSignatory = this.reviewUsersList.find(ele => ele.id == id);
    this.rfeTaskForm.patchValue({
      selectedDesignation: this.selectedSignatory.designation,

    });
    this.selectedDesignation = this.selectedSignatory.designation;
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }
  attorneySelected() {
    let attorneyId = this.rfeTaskForm.get('attorneyId').value;
    if (attorneyId && attorneyId !== "") {
      this.lookupService.getUsersOfCompany(attorneyId).subscribe((data: Array<any>) => {
        this.attorneyUsers = data;
      });
    }
    else {
      this.attorneyUsers = [];
    }
  }

  userPreparerSelected() {
    sessionStorage.setItem("setPreparerAttorneyId", "undefined");
    let id = this.rfeTaskForm.get('preparerAttorneyId').value;
    this.selectedPreparer = this.attorneyUsers.find(ele => ele.id == id);
  }

  onPetitionerPreparerSelected() {
    let id = this.rfeTaskForm.get('immSpecialistId').value;
    this.selectedPetetionPreprarer = this.users.find(ele => ele.id == id);
    sessionStorage.setItem("setPreparerAttorneyId", this.selectedPetetionPreprarer['id']);
  }



  ngOnDestroy() {
    //removing sub form controls from the parent form
    if (this.rfeTaskForm) {
      for (const [key, value] of Object.entries(this.rfeTaskForm.controls)) {
        this.parentFormGroup.removeControl(key);
      }
    }
    sessionStorage.setItem("setPreparerAttorneyId", "undefined");
  }

}
